import Vue from "vue"
import VueTurbo from "@/mixins/vue-turbo"

Vue.use(VueTurbo)
